import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GocooEngineComponent } from '@ktvs8/gocoo-engine-front-end';

const routes: Routes = [
  { path: 'gocooEngine/:viewType/:dataType/:editType/:isBack', component: GocooEngineComponent },
  { path: 'gocooEngine/:viewType/:dataType/:editType', component: GocooEngineComponent },
  { path: '', redirectTo: 'gocooEngine/weekTimeTable/Program/readonly', pathMatch: 'full' },
  { path: '**', redirectTo: 'gocooEngine/weekTimeTable/Program/readonly', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
